import {
    SprayApplicationRate,
    SprayProductPerUnitType
} from 'services/sprayEvents/types';
import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectUnitTypeFieldValue } from 'services/unitTypes/selectors';
import { OwnProps } from './index';
import {
    HECTARE,
    HUNDRED_LITRE
} from '../../../ProductRatePerUnitTypeDropdown/constants';

const selectUnits = (state: AppState, props: OwnProps): number =>
    props.units || 0;

const selectPerUnitType = (
    state: AppState,
    props: OwnProps
): SprayProductPerUnitType => props.perUnitType;

const selectApplicationRate = (
    state: AppState,
    props: OwnProps
): SprayApplicationRate => props.applicationRate;

const selectRate = createDeepEqualSelector(
    selectUnits,
    selectApplicationRate,
    makeSelectUnitTypeFieldValue('name'),
    selectPerUnitType,
    (units, applicationRate, unitTypeName, perUnitType) => {
        if (!unitTypeName) return '';

        if (perUnitType === HECTARE) {
            return `${Number((units * 100) / applicationRate).toFixed(
                2
            )} ${unitTypeName}/100L`;
        }

        if (perUnitType === HUNDRED_LITRE) {
            return `${Number((units * applicationRate) / 100).toFixed(
                2
            )} ${unitTypeName}/Ha`;
        }

        return '';
    }
);

const makeSelectRate = (): typeof selectRate => selectRate;

export { makeSelectRate };
